// Define interfaces for your entities if needed
export interface Profession {
    id: number;
    professionName: string;
    professionKey: string;
    colorHex?: string | null;
}

export enum UserRole {
    ADMIN = 'ADMIN',
    PLANNER = 'PLANNER',
    RECRUITER = 'RECRUITER',
    CLEANER = 'CLEANER',
    FINANCIAL = 'FINANCIAL',
    ACCOUNTMANAGER = 'ACCOUNTMANAGER'
}

// Define the interface that matches your AllSettingsDto
export interface AllSettings {
    professions: Profession[];
    workerStatuses: string[];
    availabilityStatuses: string[];
    userRoles: UserRole[];
    defaultLanguage?: string;
}
